<script>
    import { onMount, onDestroy } from 'svelte';
    import {Link, navigate} from "svelte-routing";
    import {checkInvoiceStatus, buyPremium} from "../lib/ApiRequests.svelte";
    import LoadingIcon from "../components/LoadingIcon.svelte";
    import {_} from '../lib/i18n';
    import {Constans} from "../lib/Constants";
    import {calcTimeByOffset, parseDateFromString} from "../lib/Common.svelte";

    export let params = {};
    let path = '';
    $: path = (params && params.path) ? params.path : '';

    export let locale = 'ru-RU';
    export let identity = {};
    export let analyzes = [];

    export let showSpecialOffers = false;

    export let orderInfo;
    //$: showSpecialOffers = (orderInfo && orderInfo.data && (orderInfo.data.type === 'trial'));

    let interval = null;
    let intervalIsActive = false;
    onMount(async () => {
        console.log(analyzes);
        //window.scrollTo(0, 0);

        setTitle($_('orderSuccess.panelTitle'));

        try {
            const urlParams = new URLSearchParams(window.location.search);
            interval = setInterval(async () => {
                if (intervalIsActive) return;
                intervalIsActive = true;
                orderInfo = await checkInvoiceStatus(urlParams.get('id'));
                intervalIsActive = false;

                applyPayment();

                if (orderInfo.data.status === 3) {
                    clearInterval(interval);
                }
            }, 1000);
        } catch (err) {
            console.error(err);
        }
    });

    function setTitle(title) {
        try {
            if (params && params.setState instanceof Function) {
                params.setState({
                    pageTitle: title,
                });
            }
        } catch (err) {
            console.error(err);
        }
    }

    let premiumPaymentIsLoading = false;
    async function buyPremiumRequest() {
        premiumPaymentIsLoading = true;
        const response = await buyPremium('premium-from-order-success-page', 'yandex_kassa');
        premiumPaymentIsLoading = false;
        if (response.status === 'ok') {
            navigate(`${path}/dashboard/order/${response.invoiceId}`);
        }
    }

    function applyPayment() {
        try {
            identity.changeKeyValue('spy_paid_till', ((new Date()).getTime() / 1000 + 86400 * orderInfo.data.period));
            identity.changeKeyValue('spy_balance', Number(orderInfo.data.analyzes));
            identity.changeKeyValue('spy_show_first_pay_modal', false);
            const spySubscription = {
                status: 1,
                tariff: {
                    analyzes: Number(orderInfo.data.analyzes),
                    period: orderInfo.data.period,
                    type: 'spy',
                },
                price: orderInfo.data.sum,
                type: orderInfo.data.type,
                analyzes: orderInfo.data.analyzes,
            }
            if (!identity.spy_subscription) {
                identity.changeKeyValue('spy_subscription', spySubscription);
            }
            params.setState({
                initTariff: null, //orderInfo.data.period,
            });
            if (orderInfo.data.type !== 'trial') {
                identity.changeKeyValue('spy_has_full_payments', true);
            }
        } catch (err) {
            console.error(err);
        }
    }

    function goToDashboard() {
        applyPayment();
        startReanalyze();

        navigate(`${path}/dashboard/`);
    }

    let startInProgress = false;
    async function startReanalyze() {
        if (locale === 'ru-RU') {
            if (analyzes.length === 1 && analyzes[0].temporary === true && identity.spy_balance > 0) {
                startInProgress = true;
                const result = await params.createAnalyze(analyzes[0].account.username, 1, 0);
                if (result) {
                    console.log(result);
                }
                startInProgress = false;
            }
            return;
        }

        for (let i = 0; i < analyzes.length; i++) {
            const analyze = analyzes[i];
            if (analyze.temporary) continue;

            const lastRevisionDate = parseDateFromString(analyze.feedsLastUpdateDate);
            const refreshAvailable = (calcTimeByOffset(Constans.timeZoneOffset).getTime() > (lastRevisionDate.getTime() + 86400 * 1000 * Constans.reanalyzeAvailableInDays));
            if (refreshAvailable) {
                analyze.forceFeedUpdate();
            }
        }
    }
</script>

<div class="canvas__col">
    <section class="payment-success-block tail">
        <h2 class="payment-success-block__title tail__title">{$_('orderSuccess.title')}</h2>
        <p class="payment-success-block__text tail__text">
            {@html $_('orderSuccess.description')}
        </p>
        <a href={`${path}/dashboard/`}
           class="button button_shadow payment-success-block__btn"
           on:click|preventDefault={goToDashboard}>
            <LoadingIcon show={startInProgress} width="16" height="16" color="#fff" />
            {$_('orderSuccess.startAnalyzeBtnLabel')}
        </a>
    </section>

    {#if showSpecialOffers}
    <section class="special-offer">
        <h3 class="special-offer__title">{$_('orderSuccess.specialOfferTitle')}</h3>
        <p class="special-offer__subtitle">{$_('orderSuccess.specialOfferSubtitle')}</p>
        <div class="special-offer__wrapper">
            <!-- Сюда помещаются карточки специальных предложений -->
            <a href={`${path}/dashboard/`} class="special-premium-banner">
                <p class="special-premium-banner__title">{$_('orderSuccess.specialOfferBannerTitle')}</p>
                <p class="special-premium-banner__text">
                    {@html $_('orderSuccess.specialOfferBannerDescription')}
                </p>
                <div class="special-premium-banner__controls-wrapper">
                    <button class="button special-premium-banner__btn"
                            on:click|preventDefault={buyPremiumRequest}
                    >
                        <LoadingIcon show={premiumPaymentIsLoading} width="16" height="16" color="#fff" />
                        {$_('orderSuccess.specialOfferBannerBuyBtnLabel')}
                    </button>
                    <div class="special-premium-banner__price">
                        <p class="special-premium-banner__price-current">{$_('orderSuccess.specialOfferBannerCurrentPrice')}</p>
                        <p class="special-premium-banner__price-old">{$_('orderSuccess.specialOfferBannerOldPrice')}</p>
                    </div>
                </div>
                <img src="/spy20-lk/img/special-premium-banner/premium-special.svg" alt="АКЦИЯ" class="special-premium-banner__img" />
            </a>
        </div>
        <p class="special-offer__disclaimer">
            {@html $_('orderSuccess.specialOfferDisclaimer')}
        </p>
    </section>
    {/if}
</div>

<style>

</style>